export default __webpack_public_path__ + "static/media/maletin.8b7b7ec9.png";